import { render, staticRenderFns } from "./fwTem.vue?vue&type=template&id=f1829888"
import script from "./fwTem.vue?vue&type=script&lang=js"
export * from "./fwTem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports